/* eslint-disable no-inner-declarations */

function throttle(fn, threshholdMs) {
  let last
  let deferTimer
  return (...args) => {
    const now = Date.now()
    if (last && now < last + threshholdMs) {
      clearTimeout(deferTimer)
      deferTimer = setTimeout(() => {
        last = now
        fn(...args)
      }, threshholdMs)
    } else {
      last = now
      fn(...args)
    }
  }
}

if (!window.nrkValgStaticSizeElements) {
  function parseSizes(queryUnparsed) {
    return queryUnparsed.split(',').map(size => {
      const operands = size.split('=')
      return {name: operands[0], width: parseInt(operands[1], 10)}
    })
  }

  function sizeElement(element) {
    requestAnimationFrame(() => {
      const elementWidth = element.clientWidth
      const queryUnparsed = element.getAttribute('data-element-query') || ''
      const size = parseSizes(queryUnparsed).filter(size => {
        return size.width <= elementWidth
      })[0]
      element.className = size ? size.name : ''
    })
  }

  function sizeElements() {
    const divs = document.querySelectorAll('[data-element-query]')
    let i
    for (i = 0; i < divs.length; ++i) {
      sizeElement(divs[i])
    }
  }

  let frame
  function handleResize() {
    if (frame) {
      cancelAnimationFrame(frame)
    }
    frame = requestAnimationFrame(sizeElements)
  }

  window.addEventListener('resize', throttle(handleResize, 50))
  window.addEventListener('orientationchange', throttle(handleResize, 50))
  window.nrkValgStaticSizeElement = sizeElement
  window.nrkValgStaticSizeElements = sizeElements
}

// Resize elements initially (for Kurator)
window.nrkValgStaticSizeElements()



// WEBPACK FOOTER //
// ./src/client/elementQuery.js